<health-data-page
    [chartLabel]="chartLabel"
    [chartConfiguration]="chartConfiguration"
    [healthDataLabel]="healthDataLabel"
    [healthDataType]="heightHealthDataType"
    [hasTwoDecimals]="hasTwoDecimals"
    [payloadTypes]="payloadTypes"
/>
